import { Link } from "@remix-run/react";
import {
  IconBrandTypescript,
  IconBrandJavascript,
  IconBrain,
  IconBrandReact,
  IconBrandVue,
  IconBrandAngular,
  IconBrandSvelte,
  IconCode,
  IconChartBar,
  IconTable,
  IconForms,
  IconPalette,
  IconDatabase,
  IconTools,
  IconFileTypeTs,
  IconTestPipe,
  IconRobot,
  IconChartDots,
  IconPlugConnected,
} from "@tabler/icons-react";
import { cn } from "~/lib/utils";

const NO_LINKS = true;

const footerLinks = [
  {
    title: "TypeScript",
    href: "/cat/typescript/all",
    icon: IconBrandTypescript,
    links: [
      {
        name: "Utility Libraries",
        href: "/cat/typescript/utilities",
        icon: IconTools,
      },
      {
        name: "Type Definitions",
        href: "/cat/typescript/types",
        icon: IconFileTypeTs,
      },
      { name: "Build Tools", href: "/cat/typescript/build", icon: IconTools },
      {
        name: "Testing Libraries",
        href: "/cat/typescript/testing",
        icon: IconTestPipe,
      },
    ],
  },
  {
    title: "JavaScript",
    href: "/cat/javascript/all",
    icon: IconBrandJavascript,
    links: [
      {
        name: "Utility Libraries",
        href: "/cat/javascript/utilities",
        icon: IconTools,
      },
      {
        name: "Data Manipulation",
        href: "/cat/javascript/data",
        icon: IconDatabase,
      },
      {
        name: "Async Libraries",
        href: "/cat/javascript/async",
        icon: IconCode,
      },
      {
        name: "Testing Libraries",
        href: "/cat/javascript/testing",
        icon: IconTestPipe,
      },
    ],
  },
  {
    title: "AI",
    href: "/cat/ai/all",
    icon: IconBrain,
    links: [
      { name: "Libraries for Web", href: "/cat/ai/web", icon: IconCode },
      { name: "Model Libraries", href: "/cat/ai/models", icon: IconRobot },
      {
        name: "Data Processing",
        href: "/cat/ai/data-processing",
        icon: IconDatabase,
      },
      {
        name: "Visualization Tools",
        href: "/cat/ai/visualization",
        icon: IconChartDots,
      },
      {
        name: "Integration Libraries",
        href: "/cat/ai/integration",
        icon: IconPlugConnected,
      },
    ],
  },
  {
    title: "React",
    href: "/cat/react/all",
    icon: IconBrandReact,
    links: [
      {
        name: "Chart Libraries",
        href: "/cat/react/charting",
        icon: IconChartBar,
      },
      { name: "Table Libraries", href: "/cat/react/table", icon: IconTable },
      { name: "Form Libraries", href: "/cat/react/form", icon: IconForms },
      { name: "UI Libraries", href: "/cat/react/ui", icon: IconPalette },
      {
        name: "State Management",
        href: "/cat/react/state",
        icon: IconDatabase,
      },
    ],
  },
  {
    title: "Vue",
    href: "/cat/vue/all",
    icon: IconBrandVue,
    links: [
      {
        name: "Chart Libraries",
        href: "/cat/vue/charting",
        icon: IconChartBar,
      },
      { name: "Table Libraries", href: "/cat/vue/table", icon: IconTable },
      { name: "Form Libraries", href: "/cat/vue/form", icon: IconForms },
      { name: "UI Libraries", href: "/cat/vue/ui", icon: IconPalette },
      { name: "State Management", href: "/cat/vue/state", icon: IconDatabase },
    ],
  },
  {
    title: "Angular",
    href: "/cat/angular/all",
    icon: IconBrandAngular,
    links: [
      {
        name: "Chart Libraries",
        href: "/cat/angular/charting",
        icon: IconChartBar,
      },
      { name: "Table Libraries", href: "/cat/angular/table", icon: IconTable },
      { name: "Form Libraries", href: "/cat/angular/form", icon: IconForms },
      { name: "UI Libraries", href: "/cat/angular/ui", icon: IconPalette },
      {
        name: "State Management",
        href: "/cat/angular/state",
        icon: IconDatabase,
      },
    ],
  },
  {
    title: "Svelte",
    href: "/cat/svelte/all",
    icon: IconBrandSvelte,
    links: [
      {
        name: "Chart Libraries",
        href: "/cat/svelte/charting",
        icon: IconChartBar,
      },
      { name: "Table Libraries", href: "/cat/svelte/table", icon: IconTable },
      { name: "Form Libraries", href: "/cat/svelte/form", icon: IconForms },
      { name: "UI Libraries", href: "/cat/svelte/ui", icon: IconPalette },
      {
        name: "State Management",
        href: "/cat/svelte/state",
        icon: IconDatabase,
      },
    ],
  },
  {
    title: "Solid",
    href: "/cat/solidjs/all",
    icon: IconCode,
    links: [
      {
        name: "Chart Libraries",
        href: "/cat/solidjs/charting",
        icon: IconChartBar,
      },
      { name: "Table Libraries", href: "/cat/solidjs/table", icon: IconTable },
      { name: "Form Libraries", href: "/cat/solidjs/form", icon: IconForms },
      { name: "UI Libraries", href: "/cat/solidjs/ui", icon: IconPalette },
      {
        name: "State Management",
        href: "/cat/solidjs/state",
        icon: IconDatabase,
      },
    ],
  },
  {
    title: "Qwik",
    href: "/cat/qwik/all",
    icon: IconCode,
    links: [
      {
        name: "Chart Libraries",
        href: "/cat/qwik/charting",
        icon: IconChartBar,
      },
      { name: "Table Libraries", href: "/cat/qwik/table", icon: IconTable },
      { name: "Form Libraries", href: "/cat/qwik/form", icon: IconForms },
      { name: "UI Libraries", href: "/cat/qwik/ui", icon: IconPalette },
      { name: "State Management", href: "/cat/qwik/state", icon: IconDatabase },
    ],
  },
];

export function Footer() {
  return (
    <footer className="bg-background border-t mt-20">
      <div className="container mx-auto py-10">
        {!NO_LINKS && (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8">
            {footerLinks.map((section) => (
              <div key={section.title} className="space-y-3">
                <h3 className="text-sm font-medium">
                  <Link
                    to={section.href}
                    className="hover:underline flex items-center"
                  >
                    <section.icon size={18} className="mr-2" />
                    {section.title}
                  </Link>
                </h3>
                <ul className="space-y-1">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.href}
                        className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
        <div
          className={cn(
            "flex flex-col items-center",
            !NO_LINKS && "mt-10 border-t pt-8"
          )}
        >
          <p className="text-sm text-muted-foreground mb-3">
            Made with <span className="text-pink-500">❤️</span> by
          </p>
          <a
            onClick={() => {
              window.gtag("event", "footer_logo_click");
            }}
            href="https://builder.io"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://cdn.builder.io/api/v1/image/assets%2Ff5348105e75441b59830f1e489577801%2F92032d8e6acb42ffad04c99e318c8884"
              alt="Builder.io logo"
              className="object-contain mb-6 dark:invert dark:hue-rotate-180"
              width={180}
              height={100}
            />
          </a>
          <p className="text-center text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} Builder.io. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
